
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'src/shared/models/app-settings.model';
import { environment } from 'environments/environment';
import version from '../../../version.json';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ConfigService {
	appSettings: AppSettings;

	constructor(private _http: HttpClient) {
		this.appSettings = new AppSettings();
	}

    public getConfigUri(): string {
        var configProd = `app-settings.json?ver=${version}`, 
            configQA = `app-settings.development.json?ver=${version}`, 
            configDev = `app-settings.development.json?ver=${version}`, 
            configMock = `app-settings.development.json?ver=${version}`, 
            configDockerLocal = `app-settings.dockerlocal.json?ver=${version}`;

        return { 'PROD': configProd, 'QA': configQA, 'DEV': configDev, 'MOCK': configMock, 'DockerLocal': configDockerLocal }[ environment.type ];
    }

	public load(): Promise<AppSettings> {
		var uri = this.getConfigUri();
		var promise = firstValueFrom(this._http.get<AppSettings>(uri));
	
		promise.then(res => this.appSettings = res);

	    return promise;
	}
}
